const FAVORITE_WEBHOOK_URL = "https://script.google.com/macros/s/AKfycbxUoSGEfp4k5kbgkLPbnWTfEd7XiY71Q5UxpiGbjQJK8HHZd0KJMQl-pndH9c0KDdHeEg/exec";

function getAnonymousUserId() {
  const KEY = "gib_favorite_user_id";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = "fav_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, id);
  }
  return id;
}

function sendFavoriteEvent(handle, title) {
  return fetch(FAVORITE_WEBHOOK_URL, {
    method: "POST",
    mode: "no-cors",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify({
      anonymous_user_id: getAnonymousUserId(),
      product_handle: handle,
      product_title: title,
      page_url: window.location.href
    })
  });
}

(() => {
  const KEY = "gib_favorites";

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch (e) { return []; }
  }

  function write(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
  }

  function setVisual(btn, on) {
    btn.classList.toggle("is-favorited", on);
    btn.setAttribute("aria-pressed", on ? "true" : "false");
  }

  function toggle(handle, btn) {
    const list = read();
    const i = list.indexOf(handle);
    const on = i === -1;
    if (on) list.push(handle);
    else list.splice(i, 1);
    write(list);
    setVisual(btn, on);
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".favorite-btn");
    if (!btn) return;
    const handle = btn.dataset.handle;
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    const wasFavorited = btn.classList.contains("is-favorited");
    toggle(handle, btn);
    const isNowFavorited = btn.classList.contains("is-favorited");
    if (!wasFavorited && isNowFavorited) {
      const productTitle = btn.dataset.title || document.title || "";
      sendFavoriteEvent(handle, productTitle)
        .then(() => console.log("favorite sent"))
        .catch((err) => console.error("favorite send failed", err));
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".favorite-btn[data-handle]").forEach((btn) => {
      const list = read();
      setVisual(btn, list.includes(btn.dataset.handle));
    });
  });
})();
